package com.dignicate.web.data.markdown.model

sealed interface MarkdownBlock {
    data class Heading(val level: Int, val text: String) : MarkdownBlock
    data class Paragraph(val text: String) : MarkdownBlock
    data class UnorderedList(val items: List<UnorderedListItem>) : MarkdownBlock
    data class CodeBlock(val language: String?, val code: String) : MarkdownBlock
}

sealed interface UnorderedListItem {
    data class Text(val text: String) : UnorderedListItem
    data class Link(val text: String, val url: String) : UnorderedListItem
}
